/** Envelope version; bump when fields change so consumers can handle old events. */
export const SCHEMA_VERSION = '1.0.0';
